import { AccountInfo, PublicClientApplication } from "@azure/msal-browser";

const clientId = process.env.REACT_APP_MSAL_CLIENT_ID!;
const tenantId = process.env.REACT_APP_MSAL_TENANT_ID!;
const authority = `https://login.microsoftonline.com/${tenantId}`;
const redirectUri = `${window.location.protocol}//${window.location.host}`;

const msalConfig = {
    auth: {
        clientId,
        authority,
        redirectUri
    },
    cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: true, // Set this to "true" if you are having issues on IE11 or Edge
    }
};

const msalInstance = new PublicClientApplication(msalConfig);
const scope = `api://${process.env.REACT_APP_MSAL_CLIENT_ID}/${process.env.REACT_APP_MSAL_SCOPE}`;

// Add a function to validate the tenant ID after login
const validateTenantId = (account: AccountInfo) => {
    if (account?.idTokenClaims?.tid !== tenantId) {
        console.error("User is not from the home tenant.");
        msalInstance.logout();
    }
};

export default msalInstance;
export { scope, validateTenantId };